'use strict';

module.exports = function applyFontMultiplierToNodeTheme(idea, nodeTheme) {
	if (!idea || !nodeTheme) {
		return nodeTheme;
	}
	const fontMultiplier = idea.attr.style && idea.attr.style.fontMultiplier;

	if (!fontMultiplier || nodeTheme.hasFontMultiplier || !nodeTheme.font || Math.abs(fontMultiplier) <= 0.01 || Math.abs(fontMultiplier - 1) <= 0.01) {
		return nodeTheme;
	}
	if (nodeTheme.font.size) {
		nodeTheme.font.size = nodeTheme.font.size * fontMultiplier;
	}

	if (nodeTheme.font.lineSpacing) {
		nodeTheme.font.lineSpacing = nodeTheme.font.lineSpacing * fontMultiplier;
	}

	if (nodeTheme.font.sizePx) {
		nodeTheme.font.sizePx = nodeTheme.font.sizePx * fontMultiplier;
	}
	if (nodeTheme.font.lineSpacingPx) {
		nodeTheme.font.lineSpacingPx = nodeTheme.font.lineSpacingPx * fontMultiplier;
	}
	nodeTheme.hasFontMultiplier = true;
	return nodeTheme;
};
